import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import SvgImage from "../../../../../Icons/Icons";
import "./index.css";
import moment from "moment";
import {
    getVendorLedger,clearVendorLedger
} from "../../../../../../services/Store/Actions/TripsAction";
import { wait } from "@testing-library/user-event/dist/utils";
import NoTransaction from "../../../../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/TabularData/NoTransaction";
import { ClipLoader } from "react-spinners";
import { BallTriangle } from "react-loader-spinner";
import EditLedgerExpense from "../../../../../Modals/EditLedgerExpense";
import AddNewVendor from "../../../../Components/AddNewVendor";

function LedgerHistory(props) {
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(0);
  const [offset, setOffset] = useState(0);
  const [enterPin, setEnterPin] = useState(false);
  const [paymentData, setPaymentData] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [failedMsg, setFailedMsg] = useState();
  const [editDetails, setEditDetails] = useState(false);
  const [paymetModal, setPaymentModal] = useState(false);
  const [fleetModal, setFleetModal] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [pinLoader, setPinLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const {startDate, endDate} = props

  const [show, setShow] = useState(true);
  const [isCheckAllTrips, setIsCheckAllTrips] = useState(false);
  const [isCheckTransfer, setIsCheckTransfer] = useState({});
  const [isCheckTransferLength, setIsCheckTransferLength] = useState(0);
  const [editExpense, setEditExpense] = useState(false);
  const [ledgerData, setLedgerData] = useState();
  const { vendorLedger,
    vendorLedgerList,
    tripLedgerLoader,
    vendorLedgerCount, } = useSelector(
    (state) => state?.trip
  );
  const { vendorData, path, setShowVendor } = props;
//   const isLogipeVendor = path == "0" || path == "1" || path == "2" ? "1" : "0";
const navigate = useNavigate();

  const dispatch = useDispatch();
  const trxnCount = vendorLedger?.count;
  console.log("vendorTransactioffffnList", vendorLedger,vendorLedgerList);
  useEffect(()=> {
    setOffset(0)
  },[startDate,endDate])
  const handlePrev = () => {
    if (offset > 0) {
      dispatch(clearVendorLedger());
      setOffset(offset - 5);
      dispatch(
        getVendorLedger(vendorData?.id,{
          start: startDate == "Invalid date" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          end: endDate == "Invalid date" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          limit: 5,
          offset: offset - 5,
        })
      );
    }
  };

  useEffect(() => {
    if(!editExpense){
      // dispatch(clearVendorLedger());
      dispatch(
        getVendorLedger(vendorData?.id,{
          start: startDate == "Invalid date" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          end: endDate == "Invalid date" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          limit: 5,
          offset: offset,
        })
      );
    }
  },[editExpense,startDate,endDate])
  
  // useEffect(() => {
    const closeEditExpense = () => {
      setEditExpense(false);
    };
  
    const toggleEditExpense = () => {
      setEditExpense(!editExpense);
    };
  
    const showEditExpense = (data) => {
      console.log("kkkkllllllllll", data);
      setLedgerData({...data,Vendor : {name : vendorData?.name}});
      setEditExpense(true);
    };
  // },[isCheckTransferLength])
  const handleNext = () => {
    console.log("offset,trxnCount", offset, trxnCount);
    if (offset + 5 < trxnCount) {
      dispatch(clearVendorLedger());
      setOffset(offset + 5);
      dispatch(
        getVendorLedger(vendorData?.id,{
          start: startDate == "Invalid date" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          end: endDate == "Invalid date" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY-MM-DD'),
          limit: 5,
          offset: offset + 5,
        //   from: startDate || "",
        //   to: endDate || "",
        })
      );
    }
  };
  const datepickerRefStart = useRef();
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const datepickerRefEnd = useRef();
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  function findSearch() {}
  if (editDetails) {
    return (
      <AddNewVendor
        backPress={() => {
          setEditDetails(false);
          setShowVendor(false);
        }}
        oldDetails={vendorData}
        path={path}
      />
    );
  } else {
    return (
      <div className="vendorBg containerShadow" >

        {tripLedgerLoader ? (
          <div
            className="mt-2 boxContainer"
            style={{
              padding: 70,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BallTriangle
              height={70}
              width={70}
              radius={5}
              color="#ED752E"
              ariaLabel="ball-triangle-loading"
              wrapperClass={{}}
              wrapperStyle=""
              visible={true}
            />
          </div>
        ) : trxnCount == undefined ? (
          <NoTransaction />
        ) : trxnCount == 0 ? (
          <NoTransaction />
        ) : (
          <div className="table-for-Vendor mt-0">
            <Table className="vehicleAssignedHistory">
              <thead className="th" style={{ zIndex: 99 }}>
                <tr className="table-header-vendor-details">
                  <th className="vendor-transaction-header col-2" style={{width: "12%"}}>
                    Date & Time
                  </th>
                  <th className="vendor-transaction-header col-2">
                    Description
                  </th>
                  {/* <th className="vendor-transaction-header col-1.5">Type</th> */}
                  <th className="vendor-transaction-header col-1.5">
                  Expanse Type
                  </th>
                  <th className="vendor-transaction-header">Amount</th>
                  <th className="vendor-transaction-header">liters</th>
                  <th className="vendor-transaction-header">Closing Balance</th>
                  <th className="vendor-transaction-header" style={{width: "15%"}} >Vehicle</th>
                  <th className="vendor-transaction-header" style={{width: "15%"}}>Remarks</th>
                  <th className="vendor-transaction-header">
                    <div className="row">
                      <div className="col-6">
                      Action
                      </div>
                  {/* {isCheckTransferLength > 0 ?
                   <div className="col-6" style={{marginTop : "-2px"}}>
                    <button>
                      MARK
                    </button>
                    </div> : ""} */}
                    </div>
</th>
                  {/* <th className="col-2 vendor-transaction-header">
                    Upload / View Invoice
                  </th> */}
                  
                </tr>
              </thead>
              {/* <div className="tbodyVehicle-div"> */}
              <tbody className="tbodyVendor" style={{ textDecoration: "none" }}>
                {vendorLedgerList?.map((items, i) => {
                  console.log("-----------", i, items?.tripId);
                  return (
                    <>
                      {i < 5 && i >= 0 ? (
                        <tr className="table-row-vendor-details table-row-transaction-history">
                          <td
                            className="col-2 " 
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              width: "12%"
                            }}
                          >
                           {items?.expDate ? moment(items?.expDate).format(
                              "DD/MM/YYYY, hh:mm a"
                            ) : moment(items?.createdAt).format(
                              "DD/MM/YYYY, hh:mm a"
                            )}
                          </td>
                          <td
                            className="col-2 "
                            style={!items?.tripId ? {
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                            } : {
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                                cursor: "pointer",
                                textDecorationLine: "underline",
                                color: "blue",
                            }}
                            onClick={() => {
                              if(items?.tripId)
                                navigate(`/trips/${items?.tripId}`);
                            }}
                          >
                            {items?.description}
                          </td>
                          {/* <td
                            className="col-1.5"
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              color:
                              items?.vendorTransferType == "credit"
                                ? "#09BD7B"
                                : "#E63946",
                            }}
                          >
                            {items?.vendorTransferType?.toUpperCase()}
                          </td>  */}

                          <td
                            className="col-1.5 "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              wordBreak: "break-all",
                            }}
                          >
                            {items?.expanseTag}
                          </td>
                          {/* <td
                           className="col-2 "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              width: "12%"
                            }}
                          >
                            {items?.Fleet?.regNumber ? items?.Fleet?.regNumber  : ""}
                          </td> */}
                          <td
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              color:
                              items?.vendorTransferType == "credit"
                                ? "#09BD7B"
                                : "#E63946",
                            }}
                          >
                            ₹{items?.amount}
                            
                          </td>
                          <td
                            className="col-1.5 "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              wordBreak: "break-all",
                            }}
                          >
                           {items?.litres}
                          </td>
                          <td
                            className="col-1.5 "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              wordBreak: "break-all",
                            }}
                          >
                            {"₹ " + items?.closingBal || "0"}
                          </td>
                          <td
                            className=" "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              wordBreak: "break-all",
                              cursor: "pointer",
                              textDecorationLine: "underline",
                              color: "blue",
                              width: "15%"
                            }}
                            onClick={() => {
                              if (items?.Fleet) navigate(`/VehiclesV2/${items?.fleetId}?search=${items?.Fleet?.regNumber}&offset=0`);
                              else if(items?.Trip) navigate(`/trips/${items?.tripId}`)
                            }}
                          >
                            {items?.Fleet ? items?.Fleet?.regNumber : items?.Trip ? "Trip-" + items?.Trip?.TripNo : ""}
                          </td>
                          <td
                            className="col-2"
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                              wordBreak: "break-word"
                              // color:
                              //   items?.status == "Success"
                              //     ? "#09BD7B"
                              //     : "#E63946",
                            }}
                          >
                            {items?.remarks}
                          </td>
                          <td style={{                             
                             verticalAlign: "middle",
                              borderRightWidth: 1, }}>
                        <div
                          onClick={() => {
                            console.log("adsfghwerter");
                          }}
                        >
                          {console.log("tt?.[0]?.fleetId ----- ", isCheckTransfer)}
                          {/* <input
                            type="checkbox"
                            name="trips2"
                            id={items?.tripLedgerId}
                            checked={
                              setIsCheckTransfer?.[items?.tripLedgerId]?.tripLedgerId
                            }
                            onChange={(e) => {
                              console.log(
                                "===<<<<<nmtknikn1",
                                items?.tripLedgerId
                              );
                              const { id, checked } = e.target;
                              console.log("===<<<<<nmtknikn1", id, checked);
                              let x = isCheckTransfer;
                              if (checked) {
                                x[items?.tripLedgerId] = items;
                                setIsCheckTransferLength(isCheckTransferLength + 1);
                              } else {
                                delete x[items?.tripLedgerId];
                                setIsCheckTransferLength(isCheckTransferLength - 1);
                              }
                              setIsCheckTransfer(x);
                            }}
                            disabled={
                              items?.vendorTransferType == "debit" ? true : Object.values(isCheckTransferLength) == 0
                                ? false
                                : items.tripLedgerId !=
                                  Object.values(isCheckTransferLength)?.[0]?.tripLedgerId
                            }
                          /> */}
                                                   <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            showEditExpense(items);
                          }}
                        >
                          Edit
                        </button>
                        </div>
                      </td>

                          {/* <td
                            className="col-2 "
                            style={{
                              verticalAlign: "middle",
                              borderRightWidth: 1,
                            }}
                          >
                            <div className="row">
                              <div className="col-1 upload-Icon" type="button">
                                <SvgImage name="uploadIconV2" />
                                <div style={{ position: "absolute" }}>
                                  <input
                                    type="file"
                                    // accept="image/*"
                                    className="add-attachment-btn-4"
                                    onChange={async (e) => {
                                      const img = e?.target.files[0];
                                      // setFileUp( e?.target.files[0]);
                                      console.log("image", img?.name);
                                      if (img !== null) {
                                        //notify2();
                                        dispatch(
                                          vendorUploadBillAction(
                                            {
                                              transaction_id:
                                                items?.transaction_id,
                                              img: img,
                                            },
                                            (res) => {
                                              if (res?.type == "success") {
                                                setSuccessModal(true);
                                                setSuccessText(
                                                  `Image Uploaded Successfully`
                                                );
                                                wait(1400).then(() => {
                                                  dispatch(
                                                    cleanVendorTransaction()
                                                  );
                                                  dispatch(
                                                    vendorTransactionAction({
                                                      limit: 5,
                                                      offset: offset,
                                                      from: "",
                                                      to: "",
                                                      vendorId: vendorData?.id,
                                                    })
                                                  );
                                                });
                                              } else {
                                                setFailedMsg(
                                                  res?.data?.message
                                                );
                                                setFailedModal(true);
                                              }
                                            }
                                          )
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              {items?.doc_url != null && (
                                <div
                                  className="col-1"
                                  onClick={() => {
                                    dispatch(
                                      vendorGetSignedUrlAction(
                                        { key: items?.doc_url },
                                        (res) => {
                                          console.log(
                                            "vendorGetSignedUrlAction",
                                            res
                                          );
                                          if (res?.status == 200) {
                                            window.open(
                                              res?.data?.data,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                          }
                                        }
                                      )
                                    );
                                  }}
                                >
                                  <SvgImage name="ViewInvoice" />
                                </div>
                              )}
                            </div>
                          </td> */}
                        </tr>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </tbody>
              {/* </div> */}
            </Table>
            
            {trxnCount > 0 && (
              <div className="row margin0 padding16">
                <div
                  className="col-4"
                  style={{
                    textAlign: "right",
                    paddingTop: "0.1rem",
                    cursor: offset > 0 ? "pointer" : "no-drop",
                    opacity: offset > 0 ? "1" : "0.5",
                  }}
                  onClick={handlePrev}
                >
                  <SvgImage name="PrevArrow" />
                </div>
                <div
                  className="col-1 greenFont semiBold heading4 padding0L"
                  style={{
                    textAlign: "right",
                    paddingTop: "0.3rem",
                    cursor: offset > 0 ? "pointer" : "no-drop",
                    opacity: offset > 0 ? "1" : "0.5",
                  }}
                  onClick={handlePrev}
                >
                  Previous
                </div>
                <div className="col-2 row margin0 justify-content-center">
                  <div
                    className="greenBoxCount Medium heading4 col-4"
                    style={{
                      width: "2rem",
                      height: "2rem",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {offset / 5 + 1}
                  </div>
                  <div
                    className=" col-4 padding0R"
                    style={{ paddingTop: "0.3rem", textAlign: "right" }}
                  >
                   <div style={{display: "flex", flexDirection: "row"}}>
                      <div>of{" "}</div>
                      <div style={{marginLeft: "10px"}}>{trxnCount % 5 == 0
                      ? Math.floor(trxnCount / 5)
                      : Math.floor(trxnCount / 5 + 1)}</div>
                    </div>
                    
                  </div>
                </div>
                <div
                  className="col-1 greenFont semiBold heading4 padding0R"
                  style={{
                    textAlign: "left",
                    paddingTop: "0.3rem",
                    cursor: trxnCount - offset > 5 ? "pointer" : "no-drop",
                    opacity: trxnCount - offset > 5 ? "1" : "0.5",
                  }}
                  onClick={handleNext}
                >
                  Next
                </div>
                <div
                  className="col-4 padding0L"
                  style={{
                    textAlign: "left",
                    marginLeft: "-1rem",
                    paddingTop: "0.1rem",
                    cursor: trxnCount - offset > 5 ? "pointer" : "no-drop",
                    opacity: trxnCount - offset > 5 ? "1" : "0.5",
                  }}
                  onClick={handleNext}
                >
                  <SvgImage name="NextArrow" />
                </div>
              </div>
            )}
          </div>
        )}
        {editExpense ? 
                  <EditLedgerExpense
                  open={editExpense}
                  ledgerData={ledgerData}
                  toggleModal={toggleEditExpense}
                  handleClose={closeEditExpense}
                  name="Edit Ledger"
                  fleetId={props.fleetId}
                  driverBal={"SCDa"}
                  cardType={1}
                  vehRegNo={props.vehRegNo}
                /> : <></>
        }
      </div>
    );
  }
}
export default LedgerHistory;
